export function EgnValid(egn) {
    if (egn == null) {
        return false;
    }

    const EGN_WEIGHTS = [2, 4, 8, 5, 10, 9, 7, 3, 6];

    if (egn.length !== 10)
        return false;

    const year = parseInt(egn.substring(0, 2), 10);
    const mon = parseInt(egn.substring(2, 4), 10);
    const day = parseInt(egn.substring(4, 6), 10);

    if (mon > 40) {
        if (!isValidDate(mon - 40, day, year + 2000)) return false;
    } else if (mon > 20) {
        if (!isValidDate(mon - 20, day, year + 1800)) return false;
    } else {
        if (!isValidDate(mon, day, year + 1900)) return false;
    }

    const checksum = parseInt(egn.substring(9, 10), 10);
    let egnsum = 0;
    for (let i = 0; i < 9; i++)
        egnsum += parseInt(egn.substring(i, i + 1), 10) * EGN_WEIGHTS[i];

    const validChecksum = egnsum % 11 === 10 ? 0 : egnsum % 11;

    if (checksum === validChecksum)
        return true;
    return false;
}

function isValidDate(month, day, year) {
    const date = new Date(year, month - 1, day);
    return (
        date.getFullYear() === year &&
        date.getMonth() + 1 === month &&
        date.getDate() === day
    );
}